var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallcallicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8557 13.1439C9.68566 11.9739 8.80366 10.6639 8.21766 9.33487C8.09366 9.05387 8.16666 8.72487 8.38366 8.50787L9.20266 7.68987C9.87366 7.01887 9.87366 6.06987 9.28766 5.48387L8.11366 4.30987C7.33266 3.52887 6.06666 3.52887 5.28566 4.30987L4.63366 4.96187C3.89266 5.70287 3.58366 6.77187 3.78366 7.83187C4.27766 10.4449 5.79566 13.3059 8.24466 15.7549C10.6937 18.2039 13.5547 19.7219 16.1677 20.2159C17.2277 20.4159 18.2967 20.1069 19.0377 19.3659L19.6887 18.7149C20.4697 17.9339 20.4697 16.6679 19.6887 15.8869L18.5157 14.7139C17.9297 14.1279 16.9797 14.1279 16.3947 14.7139L15.4917 15.6179C15.2747 15.8349 14.9457 15.9079 14.6647 15.7839C13.3357 15.1969 12.0257 14.3139 10.8557 13.1439V13.1439Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallcallicon);
export default __webpack_public_path__ + "static/media/smallcallicon.89f8f23e3a7c9aa58c9443af0485b462.svg";
export { ForwardRef as ReactComponent };